import { render, staticRenderFns } from "./CustomerRevenue.vue?vue&type=template&id=b5ce4aba&"
import script from "./CustomerRevenue.vue?vue&type=script&lang=js&"
export * from "./CustomerRevenue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports